import { Chart } from 'Generated/graphql-types'

export const calculateChartProgress = (chart?: Chart | null) => {
  if (!chart || !chart.target) return 0

  const { seriesData } = chart
  const cumulativeAmount = seriesData.reduce((sum, series) => {
    if (series) {
      const seriesSum = series.data.reduce((acc, dataPoint) => {
        if (dataPoint) return acc + (dataPoint.y ?? 0)
        return acc
      }, 0)
      return sum + seriesSum
    }
    return sum
  }, 0)
  return Math.min((cumulativeAmount / chart.target) * 100, 100)
}
